<template>
  <div class="zero">
   
    <Header />
    <div class="content">
      <img src="../../../assets/coursePage/zero/img01.png"/>
    </div>
    <Footer />
    
  </div>
</template>

<script>

import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";
export default {
  components: {
   
    Header,
    Footer,
  
  },
  data() {
    return {
      
    };
  },
  methods: {
   
  },
};
</script>

<style lang="scss" scoped>
.zero{
  .content{
    padding-top: 88px;
    img{
      width: 100%;
    }
  }
}
</style>
